import { render, staticRenderFns } from "./AdminEtikettenDruck.vue?vue&type=template&id=4f65cabf&"
import script from "./AdminEtikettenDruck.vue?vue&type=script&lang=js&"
export * from "./AdminEtikettenDruck.vue?vue&type=script&lang=js&"
import style0 from "./AdminEtikettenDruck.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports